import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Typography, withStyles} from "@material-ui/core";
import CurrencyFormatter from "currency-formatter";

const styles = (theme) => ({
  cardViewContainer: {
    width: '77.04mm',
    height: '48.58mm',
    margin: 'auto'
  },
  cardViewContainerSmall: {
    width: '57.06mm',
    height: '35.98mm',
    margin: 'auto'
  },
  cardViewContainerThumbnail: {
    width: '14.26mm',
    height: '8.99mm',
    margin: 'auto'
  },
  cardMask: {
    width: '77.04mm',
    height: '48.58mm',
    margin: 'auto',
    borderRadius: 12,
    position: 'relative',
    overflow: 'hidden',
    filter: 'drop-shadow(0px 0px 4px #000000AA)'
  },
  cardMaskSmall: {
    width: '57.06mm',
    height: '35.98mm',
    margin: 'auto',
    borderRadius: 6,
    position: 'relative',
    overflow: 'hidden',
    filter: 'drop-shadow(0px 0px 2px #00000088)'
  },
  cardMaskThumbnail: {
    width: '14.26mm',
    height: '8.99mm',
    margin: 'auto',
    borderRadius: 2,
    position: 'relative',
    overflow: 'hidden',
  },
  cardDesignImage: {
    width: '100%',
    backgroundColor: 'white'
  },
  touchRipple: {
    width: '100mm',
    height: '104mm',
    position: 'absolute',
    left: '-10mm',
    top: '-24mm',

  },
  balanceContainer: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    textShadow: '1px 1px 2px black',
  },
  balance: {
    color: '#FFFFFF',
    textAlign: 'right'
  },
  balanceLabel: {
    marginBottom: 2,
    color: '#FFFFFF',
    textAlign: 'right',
    opacity: 0.9
  }
});

const unknownCardDesignImageUrl = 'https://s3.amazonaws.com/loopz-card-design-presets/card-front-unknown.png';

const CardDesignSizeType = {
  THUMBNAIL: 'thumbnail',
  NORMAL: 'normal',
  SMALL: 'small'
};

CardDesignView.propTypes = {
  cardDesign: PropTypes.object,
  locale: PropTypes.string,
  balance: PropTypes.number,
  currencyCode: PropTypes.string,
  size: PropTypes.string,
  classes: PropTypes.object,
};

function CardDesignView({cardDesign, balance, currencyCode, locale, size = CardDesignSizeType.NORMAL, classes}) {

  function getFormattedAmount() {
    const currency = CurrencyFormatter.findCurrency(currencyCode);
    const adjustedAmount = showBalance ? balance / Math.pow(10, currency.decimalDigits) : 0;
    return CurrencyFormatter.format(adjustedAmount, {locale, code: currency.code, format: '%s%v'});
  }

  let imageUrl = unknownCardDesignImageUrl;

  const showBalance = false;//typeof balance === 'number';

  if (cardDesign && cardDesign.frontImageUrl) {
    imageUrl = cardDesign.frontImageUrl;
  }

  let cardViewContainerClass = classes.cardViewContainer;
  let cardMaskClass = classes.cardMask;

  switch(size) {
    case CardDesignSizeType.NORMAL:
      cardViewContainerClass = classes.cardViewContainer;
      cardMaskClass = classes.cardMask;
      break;
    case CardDesignSizeType.SMALL:
      cardViewContainerClass = classes.cardViewContainerSmall;
      cardMaskClass = classes.cardMaskSmall;
      break;
    case CardDesignSizeType.THUMBNAIL:
      cardViewContainerClass = classes.cardViewContainerThumbnail;
      cardMaskClass = classes.cardMaskThumbnail;
      break;
    default:
  }

  return (
    <div className={cardViewContainerClass}>
      <div
        className={cardMaskClass}>
        <img src={imageUrl} alt="selected card design" className={classes.cardDesignImage}/>
        {showBalance &&
        <div className={classes.balanceContainer}>
          <div>
            <Typography className={classes.balanceLabel} variant={'subtitle1'}>
              <FormattedMessage id={'label.balance'}/>
            </Typography>
            <Typography className={classes.balance} variant={'h5'}>
              {getFormattedAmount()}
            </Typography>
          </div>
        </div>
        }
      </div>
    </div>
  );

}

export default withStyles(styles)(CardDesignView);
